import { useState } from "react"

export const CookiesService = {
  delete: function deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
  },
  get: function getCookieValue(name: string): string | undefined {
    const matches = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`,
      ),
    )

    return matches && matches[1] ? decodeURIComponent(matches[1]) : undefined
  },
  set: function setCookie(name: string, value: string, days?: number) {
    let expires = ""
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 864e5) // 864e5 = 24*60*60*1000
      expires = `; expires=${date.toUTCString()}`
    }

    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`
  },
}

export function useCookie(name: string) {
  const [cookie, setCookieState] = useState(() => CookiesService.get(name))

  const updateCookie = (value: string, days?: number) => {
    CookiesService.set(name, value, days)
    setCookieState(value)
  }

  const removeCookie = () => {
    CookiesService.delete(name)
    setCookieState(undefined)
  }

  return [cookie, updateCookie, removeCookie] as const
}
